module.exports = ".title {\r\n    margin-bottom: 1.5rem;\r\n}\r\n"